import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import("@mui/material/SvgIcon").SvgIconProps} props
 * @returns {React.ReactNode}
 * @constructor
 */
const LogoPayPalComponent = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        height="339.35"
        viewBox="0 0 338.67 89.78"
        width="1280"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M108.3 17.96c-.7 0-1.3.5-1.4 1.19l-8.07 51.17a1.31 1.31 0 0 0 1.3 1.5h9.56c.7 0 1.29-.5 1.4-1.19l2.37-15.02c.1-.69.7-1.2 1.4-1.2h8.7c10.16 0 18.79-7.41 20.36-17.46 1.6-10.14-6.33-18.97-17.55-19zm9.3 11.42h6.95c5.73 0 7.6 3.38 7.01 7.12-.59 3.74-3.49 6.5-9.03 6.5h-7.08zm45.78 3.48c-2.41 0-5.2.5-8.31 1.8-7.16 2.98-10.6 9.15-12.06 13.65 0 0-4.65 13.71 5.85 21.25 0 0 9.74 7.25 20.7-.45l-.19 1.2a1.31 1.31 0 0 0 1.3 1.52h9.08c.7 0 1.28-.5 1.4-1.2l5.52-35.03a1.31 1.31 0 0 0-1.3-1.52h-9.08c-.7 0-1.29.5-1.4 1.2l-.3 1.88s-3.96-4.33-11.2-4.3zm.3 11.06c1.04 0 2 .15 2.85.42a8.03 8.03 0 0 1 5.5 9.1 10.17 10.17 0 0 1-10.2 8.73c-1.04 0-2-.14-2.85-.42a8.04 8.04 0 0 1-5.51-9.1c.8-5.03 4.92-8.73 10.21-8.73z"
          fill="#003087"
        />
        <path
          d="M239.1 17.96c-.7 0-1.3.5-1.4 1.19l-8.07 51.17a1.31 1.31 0 0 0 1.3 1.5h9.56c.7 0 1.29-.5 1.4-1.19l2.37-15.02c.1-.69.7-1.2 1.4-1.2h8.7c10.16 0 18.79-7.41 20.36-17.46 1.6-10.14-6.32-18.97-17.55-19zm9.3 11.42h6.96c5.73 0 7.6 3.38 7 7.12-.59 3.74-3.49 6.5-9.03 6.5h-7.08zm45.78 3.48c-2.41 0-5.2.5-8.31 1.8-7.16 2.98-10.6 9.15-12.06 13.65 0 0-4.65 13.71 5.85 21.25 0 0 9.74 7.25 20.7-.45l-.19 1.2a1.31 1.31 0 0 0 1.3 1.52h9.08c.7 0 1.28-.5 1.4-1.2l5.52-35.03a1.31 1.31 0 0 0-1.3-1.52h-9.08c-.7 0-1.29.5-1.4 1.2l-.3 1.88s-3.96-4.33-11.2-4.3zm.3 11.06c1.04 0 2 .15 2.85.42a8.03 8.03 0 0 1 5.5 9.1 10.17 10.17 0 0 1-10.2 8.73c-1.04 0-2-.14-2.85-.42a8.04 8.04 0 0 1-5.51-9.1c.79-5.03 4.92-8.73 10.2-8.73z"
          fill="#0070e0"
        />
        <path
          d="M190.98 34.08c-.72 0-1.23.7-1.01 1.39l9.95 30.9-9 14.56c-.44.7.07 1.62.9 1.62h10.64a1.77 1.77 0 0 0 1.52-.85l27.8-46.01c.44-.7-.07-1.61-.9-1.61h-10.64a1.77 1.77 0 0 0-1.52.87l-10.95 18.48-5.56-18.34c-.18-.6-.73-1.01-1.35-1.01z"
          fill="#003087"
        />
        <path
          d="M327.8 17.96c-.7 0-1.3.5-1.4 1.19l-8.08 51.16a1.31 1.31 0 0 0 1.3 1.52h9.57c.7 0 1.28-.5 1.4-1.2l8.06-51.16a1.31 1.31 0 0 0-1.3-1.51z"
          fill="#0070e0"
        />
        <path
          d="M28.53 17.96a2.59 2.59 0 0 0-2.56 2.18l-4.24 26.94a2.59 2.59 0 0 1 2.55-2.19h12.45a25.42 25.42 0 0 0 25.1-21.52 20.76 20.76 0 0 0 .24-2.8 23.62 23.62 0 0 0-11.02-2.61z"
          fill="#001c64"
        />
        <path
          d="M62.07 20.58a20.76 20.76 0 0 1-.25 2.8 25.42 25.42 0 0 1-25.1 21.51H24.29c-1.27 0-2.36.93-2.55 2.19l-3.91 24.75-2.45 15.53a2.1 2.1 0 0 0 2.08 2.43h13.5a2.59 2.59 0 0 0 2.56-2.19l3.56-22.56a2.59 2.59 0 0 1 2.56-2.19h7.95a25.42 25.42 0 0 0 25.1-21.52c1.38-8.79-3.05-16.78-10.61-20.75z"
          fill="#0070e0"
        />
        <path
          d="M13.18 0c-1.27 0-2.36.93-2.55 2.18L.03 69.4a2.1 2.1 0 0 0 2.07 2.43h15.72l3.9-24.75 4.25-26.94a2.59 2.59 0 0 1 2.56-2.18h22.52c4.1 0 7.83.95 11.02 2.62C62.28 9.31 52.98 0 40.19 0z"
          fill="#003087"
        />
      </svg>
    </SvgIcon>
  );
};
LogoPayPalComponent.displayName = 'LogoPayPal';
const LogoPayPal = memo(LogoPayPalComponent);
export default LogoPayPal;
